import { useRealm } from './use-realm'
import { realmLabelsStrategy } from '../utils/realm-labels-strategy'

export const useRealmLabels = () => {
  const realm = useRealm()

  return realm && realm in realmLabelsStrategy
    ? realmLabelsStrategy[realm]
    : realmLabelsStrategy.default
}
